export default function concatClassNames(...classNames) {
  return classNames.filter((x) => x && x !== "").join(" ")
}
